import { useContext } from "react";
import { Layout } from "antd";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { GeneralStore } from "../stores";
import { Link, Outlet } from "react-router-dom";
import { Footer } from "antd/es/layout/layout";
import { Title, Sidebar, MobileSidebar } from ".";
import { UserContext } from "../context/user";
import SupportChat from "../Components/SupportChat/SupportChat";

const { Content } = Layout;

export const MainLayout = () => {
  const { t } = useTranslation();
  const { pageTitle, contentPadding } = GeneralStore();
  const [context] = useContext(UserContext);
  const canShowSupport = context?.role === "Öğrenci" || context?.role === "Öğretmen";

  return (
    <>
      <Helmet>
        <html className="m-0 p-0" />
        <body className="min-h-screen duration-300 w-full !m-0 overflow-x-hidden !p-0 box-border font-sans" />
        <title>
          {pageTitle?.props?.children
            ? pageTitle.props.children + " - "
            : pageTitle?.label
            ? pageTitle.label + " - "
            : pageTitle
            ? pageTitle + " - "
            : ""}
          {t("common.appName")}
        </title>
      </Helmet>

      <Layout hasSider className="spor-app !m-0 !p-0">
        <MobileSidebar />
        <Sidebar />

        <Layout className="bg-transparent flex flex-col flex-1 w-0 min-w-0">
          <div className="spor-navbar">
            <Title />
          </div>

          <Content
            className={`spor-main ${
              contentPadding ? "" : "!p-0"
            }`}
          >
            <div className="spor-ui">
              <Outlet />
            </div>
          </Content>

          <Footer className="spor-footer text-center leading-6 py-6 min-h-[100px] bg-transparent">
            {t("layout.footer")} <br />
            <Link target="_blank" to="https://sehirteknolojileri.com/">
              {t("common.cityTechCenter")}{" "}
            </Link>
            {t("common.madeBy")}
          </Footer>
        </Layout>

        {canShowSupport && <SupportChat />}
      </Layout>
    </>
  );
};
